<template>
    <div class="row">
        <div class="col-lg-6">
            <FormGroup :label="$t('labels.name')">
                <Input
                    :model-value="smsTemplate?.name"
                    @update:model-value="smsTemplate.name = $event"
                />
            </FormGroup>
        </div>
        <div class="col-lg-6">
            <FormGroup :label="$t('labels.api_credentials')">
                <AppAutoComplete
                    :url="`/projects/${$route.params.projectUuid}/core/api-credentials`"
                    :model-value="smsTemplate?.api_credentials?.uuid"
                    :selected-value="smsTemplate?.api_credentials?.name"
                    @update:model-value="smsTemplate.api_credentials = $event"
                    :query-params="{
                        service: 'intel-tele'
                    }"
                >
                    <template #optionContent>
                        <template v-if="!smsTemplate?.api_credentials">
                            <span class="text-muted">{{ $t('labels.empty') }}</span>
                        </template>
                        <template v-else>
                            {{ smsTemplate.api_credentials.name }}
                            <span :class="['badge', smsTemplate.api_credentials.is_active ? 'badge-success' : 'badge-danger', 'ml-2']">
                                {{ smsTemplate.api_credentials.is_active ? $t('labels.active') : $t('labels.inactive') }}
                            </span>
                        </template>
                    </template>
                    <template #optionItem="{ option, index }">
                        {{ option.name }}
                        <span :class="['badge', option.is_active ? 'badge-success' : 'badge-danger', 'ml-2']">
                            {{ option.is_active ? $t('labels.active') : $t('labels.inactive') }}
                        </span>
                    </template>
                </AppAutoComplete>
            </FormGroup>
        </div>
        <div class="col-lg-8">
            <FormGroup :label="$t('labels.text')">
                <Formula
                    :formula="smsTemplate?.text"
                    @update:formula="smsTemplate.text = $event"
                    :items="formulaItems"
                />
            </FormGroup>
        </div>
        <div class="col-lg-2">
            <FormGroup :label="$t('labels.sender_name')">
                <Input
                    :model-value="smsTemplate?.sender_name"
                    @update:model-value="smsTemplate.sender_name = $event"
                />
            </FormGroup>
        </div>
        <div class="col-lg-2">
            <FormGroup :label="$t('labels.send_once')" required>
                <AppCheckbox
                    :model-value="smsTemplate?.send_once"
                    @update:model-value="smsTemplate.send_once = $event"
                />
            </FormGroup>
        </div>
    </div>
</template>

<script>
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Formula from "../../../../../components/form/FormulaComponent.vue";
import AppAutoComplete from "../../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import AppCheckbox from "../../../../../components/new/form/checkbox/AppCheckbox.vue";

export default {
    name: "MainInformationCard",
    components: {
        FormGroup,
        Input,
        Formula,
        AppAutoComplete,
        AppCheckbox
    },
    props: {
        smsTemplate: {
            type: Object,
            default: () => ({})
        },
        formulaItems: {
            type: Array,
            default: () => []
        }
    }
}
</script>